import React, { useState } from "react";
import { Modal, Tabs, Button } from "antd"; // Import Ant Design Modal and Tabs
import CookiePolicy from "./LegalPolicies/CookiePolicy";
import PrivacyPolicy from "./LegalPolicies/PrivacyPolicy";
import TermsOfService from "./LegalPolicies/TermsAndServices";
import cancelX from "../../../Assets/svg/cancelXbutton.svg"; // Import the X button image
import "./FooterComponent.scss"; // Your styling as needed

import poweredByLogo from "../../../Assets/tpmShare/KAPtech_Group_Logo.png";
import poweredByLogo1 from "../../../Assets/tpmShare/I-aps.png";
import unicefLogo from "../../../Assets/tpmShare/UNICEF_Logo.png";
import whoLogo from "../../../Assets/tpmShare/World_Health_Organization_Logo.png";
import worldBankLogo from "../../../Assets/tpmShare/World_Bank-Logo.wine.png";
import africanBankLogo from "../../../Assets/tpmShare/Mask_group.png";

const FooterComponent = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [activeTab, setActiveTab] = useState("terms");
  const publicURL = process.env.REACT_APP_API_BASE_URL;

  const handleOpenModal = (tab) => {
    setActiveTab(tab);
    setIsModalVisible(true); // Open the modal
  };

  const handleCloseModal = () => {
    setIsModalVisible(false); // Close the modal
  };

  return publicURL !== "https://shareapi.tpmready.com" ? (
    <div className="footer-container">
      <div className="footer-left">Powered by KAPtech Group</div>
      <div className="footer-right">
        <div
          className="legalPoliciesText"
          onClick={() => handleOpenModal("terms")}
        >
          Terms of Service
        </div>
        <div
          className="legalPoliciesText"
          onClick={() => handleOpenModal("privacy")}
        >
          Privacy Policy
        </div>
        <div
          className="legalPoliciesText"
          onClick={() => handleOpenModal("cookie")}
        >
          Cookie Policy
        </div>
      </div>

      <Modal
        visible={isModalVisible} // Control visibility of the modal
        onCancel={handleCloseModal} // Close modal when clicking on the overlay or close button
        footer={null} // No footer buttons
        width={800}
        closable={false} // Disable the default close button
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end", // Align X button to the right
            marginBottom: "20px",
          }}
        >
          <img
            src={cancelX}
            alt="Close"
            style={{ cursor: "pointer" }}
            onClick={handleCloseModal} // Close modal on click
          />
        </div>
        <h2 className="modalHeader">Legal Policies</h2>
        <Tabs activeKey={activeTab} onChange={(key) => setActiveTab(key)}>
          <Tabs.TabPane tab="Terms of Service" key="terms">
            {activeTab === "terms" && <TermsOfService />}
          </Tabs.TabPane>
          <Tabs.TabPane tab="Privacy Policy" key="privacy">
            {activeTab === "privacy" && <PrivacyPolicy />}
          </Tabs.TabPane>
          <Tabs.TabPane tab="Cookie Policy" key="cookie">
            {activeTab === "cookie" && <CookiePolicy />}
          </Tabs.TabPane>
        </Tabs>
        <div className="buttonsModal">
          <Button
            className="inviteButtonTPM"
            key="cancel"
            onClick={handleCloseModal}
          >
            Cancel
          </Button>
        </div>
      </Modal>
    </div>
  ) : (
    <div className="footer-container">
      <div className="footer-left">
        Powered by{" "}
        <img
          src={poweredByLogo}
          alt="KAPtech Logo"
          className="powered-by-logo"
        />
        <img
          src={poweredByLogo1}
          alt="KAPtech Logo"
          className="powered-by-logo"
          style={{ height: "38px" }}
        />
      </div>
      <div className="footer-right">
        <img src={unicefLogo} alt="UNICEF" className="partner-logo" />
        <img src={whoLogo} alt="WHO" className="partner-logo" />
        <img src={worldBankLogo} alt="World Bank" className="partner-logo" />
        <img
          src={africanBankLogo}
          alt="African Development Bank"
          className="partner-logo small"
        />
      </div>
    </div>
  );
};

export default FooterComponent;
